export function useSigned(documentId) {
  const signedDocuments = JSON.parse(localStorage.getItem('signedDocuments') || '[]');

  return signedDocuments.includes(documentId);
}
